import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const aiAssistantApi = createApi({
  reducerPath: "aiAssistantApi",
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ["AiChats", "AiConversation"],
  endpoints: (builder) => ({
    // 🔹 Ask AI a Question (POST)
    askAiQuestion: builder.mutation({
      query: ({ data }) => ({
        url: `/contractor/ai/query`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["AiChats"],
    }),

    // 🔹 Get Chats by Conversation ID
    getChatsByConversationId: builder.query({
      query: ({ conversationId }) => ({
        url: `/ai/chats/${conversationId}`,
        method: "GET",
      }),
      providesTags: (result, error, { conversationId }) => [
        { type: "AiConversation", id: conversationId },
      ],
    }),
  }),
});

// ✅ Export hooks
export const {
  useAskAiQuestionMutation,
  useGetChatsByConversationIdQuery,
} = aiAssistantApi;